import { IsNumber, IsString, ValidateNested } from "class-validator";
import { Expose, Type } from "class-transformer";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export default class CreditCardStatementItem {
  @IsString()
  @Expose()
  transactionNumber!: string; //"WR/22/12/2020/5543"
  @IsString()
  @Expose()
  transactionDate!: string; // "2020-12-01T00:00:00",
  @IsString()
  @Expose()
  accountingDate!: string; // "2020-12-01T00:00:00",
  @IsNumber()
  @Expose()
  amount!: number; // -10,
  @IsString()
  @Expose()
  description!: string;
  //"Naliczenie prowizji na karcie Opłata za korzystanie z karty 11 2020.11.02 - 2020.12.01 2020.12.01 42 z   42 ",
}

export class CreditCardStatementResponse extends GenericTableResponse<CreditCardStatementItem> {
  @Type(() => CreditCardStatementItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<CreditCardStatementItem>;
}
